export function getUI(state) {
  return state.ui;
}

export function getSelectedMenu(state) {
  return getUI(state).selectedMenu;
}

export function getSelectedCell(state) {
  return getUI(state).selectedCell;
}

export function getVisibleMenus(state) {
  return getUI(state).visibleMenus;
}

export function getColorMode(state) {
  return getUI(state).colorMode;
}

export function getGenerationsLocked(state) {
  return getUI(state).generationsLocked;
}

export function getInterfaceMode(state) {
  return getUI(state).interfaceMode;
}


// WEBPACK FOOTER //
// ./src/core/ui/selectors.js